import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import apiRequest from '../../handles/apiRequest';

const processOptions = (options) => options.map((option) => {
  return !option.value || !option.label ? {
    value: option,
    label: option,
  } : option;
});

const SelectField = (
    {
      options = [],
      requirement = {},
      mapper = {value: 'value', label: 'label'},
      onChange: handleChange = () => false,
      errorString = 'No available value',
      label = '',
      placeholder = '',
      selected = {},
      styles = {},
      optionStyles = {},
      apiEndpoint = '',
      apiParams = {},
      fieldDisabled = false,
      disabledCheck = () => false,
    }) => {
  // React State
  const [error, setError] = useState('');
  const [value, setValue] = useState(selected);
  const [values, setValues] = useState([]);

  const requirementArray = Object.values(requirement);

  // React Effect
  useEffect(() => {
    if (!fieldDisabled) {
      // Reset select options
      setValues([]);
      setValue({});

      // Load select options
      const hasValue = requirementArray.filter((e) => e.value !== undefined);
      if (!fieldDisabled && !options.length &&
          (hasValue.length === requirementArray.length)) {
        apiRequest({
          method: 'GET',
          endpoint: apiEndpoint,
          params: apiParams,
        }).then((data) => {
          const filtered = data.filter(disabledCheck);
          if (filtered.length === data.length) {
            setValues([]);
            setError(errorString);
          } else {
            setError('');
            setValues(data);
          }
        });
      }
    }
  }, [
    ...requirementArray,
    fieldDisabled,
  ]);

  useEffect(() => {
    handleChange(value);
  }, [value]);

  const defaultStyle = {
    control: (styles, state) => ({
      ...styles,
      'boxShadow': state.isFocused ? '#ddd' : 0,
      'borderColor': state.isFocused ? '#000' : '#CED4DA',
      '&:hover': {
        borderColor: state.isFocused ? '#000' : '#CED4DA',
      },
    }),
    option: (styles, state) => {
      const customStyle = {
        'color': 'rgb(128, 128, 128)',
        'borderBottom': '1px solid rgba(0, 0, 0, 0.125)',
        'backgroundColor': 'white',
        '&:hover': {
          color: 'yellow',
          backgroundColor: 'black',
        },
        'cursor': 'pointer',
      };
      if (state.isSelected) {
        customStyle.color = 'yellow';
        customStyle.backgroundColor = 'black';
        customStyle['&:hover'] = {};
      } else if (state.isDisabled) {
        customStyle.backgroundColor = '#0000001A';
        customStyle['&:hover'] = {};
        customStyle.cursor = 'default';
      }

      return ({
        ...styles,
        ...customStyle,
        ...(typeof optionStyles === 'function' ?
            optionStyles(styles, state) :
            optionStyles),
      });
    },
  };

  const errorStringStyle = {
    'lineHeight': '1.6'
  };

  const params = {
    placeholder,
    styles: {
      ...defaultStyle,
      ...styles,
    },
    options: options.length ? processOptions(options) : values.map((value) => {
      return (typeof value === 'object') ? {
        value: value[mapper['value']],
        label: value[mapper['label']],
        isDisabled: disabledCheck(value),
      } : {value, label: value};
    }),
    onChange: ({label, value}) => {
      const raw = {
        ...values.filter((item) => item[mapper['value']] === value).pop(),
        value,
        label,
      };
      setValue(raw);
    },
    isDisabled: !options.length && !values.length,
    value,
  };

  return <div className="row row_top">
    <div className="col-md-12">
      {label ? <span className="field-label">{label}</span> : ''}
      {fieldDisabled ?
          <div className="addrDiv">{selected.label}</div> :
          <Select {...params} />}
      {error ? <div style={errorStringStyle} dangerouslySetInnerHTML={{ __html: error }} /> : ''}
    </div>
  </div>;
};

SelectField.propTypes = {
  options: PropTypes.array,
  requirement: PropTypes.object,
  mapper: PropTypes.object,
  onChange: PropTypes.func,
  errorString: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  selected: PropTypes.object,
  styles: PropTypes.object,
  optionStyles: PropTypes.object,
  apiEndpoint: PropTypes.string,
  apiParams: PropTypes.object,
  fieldDisabled: PropTypes.bool,
  disabledCheck: PropTypes.func,
};

export default SelectField;
